let myName = 'Tom'
let myAge = 20
export let myfn = function () {
  return 'My name is' + myName + "! I'm '" + myAge + 'years old.'
}

export default myName



// WEBPACK FOOTER //
// ./src/mock/add.js